export const nav = {
  home: "Home",
  howItWorks: "How It Works",
  discover: "Discover",
  explore: "Explore",
  exploreDesc: "Discover members and destinations",
  destinations: "Destinations",
  destinationsDesc: "Browse available destinations",
  membersMap: "Members Map",
  membersMapDesc: "Find members near you",
  pricing: "Pricing",
  dashboard: "Dashboard",
  dashboardDesc: "Manage your listings and exchanges",
  mySpace: "My Space",
  myCalendar: "My Calendar",
  myCalendarDesc: "Manage your calendar and exchanges",
  incomingRequests: "Smart Matching",
  incomingRequestsDesc: "Received requests and AI suggestions",
  favorites: "Favorites",
  favoritesDesc: "Your favorite destinations",
  messaging: "Messaging",
  messagingDesc: "Conversations and proposals",
  login: "Login",
  signup: "Sign Up",
  corporate: "Corporate",
  announcement:
    "DONKEY TRAVEL — The European home exchange club reserved for Airbnb hosts rated 4.5 and above",
};
